import React, { useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { motion } from "framer-motion";
import { GoalFilterStatusSkeleton } from "./SkeletonDesigns";
import useResponsive from "../../../Hooks/useResponsive";

const FilterTabs = ({
  options = [],
  selected,
  onChange,
  goalStatusFilterTabLoading,
}) => {
  const scrollRef = useRef();
  const smUp = useResponsive("up", "sm");

  const scroll = (direction) => {
    if (!scrollRef.current) return;
    const scrollAmount = direction === "left" ? -150 : 150;
    scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
  };

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", bgcolor: "white", py: smUp ?  1: 0.5, }}
    >
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          gap: smUp ?  1: 0.5,
          overflowX: "auto",
          scrollbarWidth: "none", // hide scrollbar in Firefox
          "&::-webkit-scrollbar": { display: "none" }, // hide in Chrome/Safari
          flex: 1,
        }}
      >
        {goalStatusFilterTabLoading ? (
          <GoalFilterStatusSkeleton count={20} />
        ) : (
         Array.isArray(options)&& options.map((option) => {
            const isSelected = selected === option?.id;

            return (
              <motion.div
                key={option?.id}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 300 }}
                onClick={() => onChange(option?.id)}
              >
                <Box
                  sx={{
                    letterSpacing: 0.4,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    py: smUp?1:0.5,
                    px: smUp?2:1.5,
                    borderRadius: "4px",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                    fontWeight: isSelected ? 600 : 500,
                    bgcolor: isSelected ? "#2f72b3" : "white",
                    color: isSelected ? "white" : " #2f72b3",
                    border: "solid 1px #2f72b3",
                    transition: "all 0.25s ease-in-out",
                    "&:hover": {
                      bgcolor: "secondary.dark",
                      color: "white",
                    },
                  }}
                >
                  <Box component="span">
                    <Typography
                      sx={{
                        fontWeight: "medium",
                        fontSize: { xs: "0.6rem", sm: "0.7rem" },
                      }}
                      variant="inherit"
                      textTransform={"uppercase"}
                    >
                      {option?.status}
                    </Typography>
                  </Box>
                  {option?.count !== undefined && (
                    <Box
                      component="span"
                      sx={{
                        px: 1,
                        py: 0.3,
                        fontSize: "0.7rem",
                        lineHeight: 1,
                        borderRadius: "10px",
                        bgcolor: isSelected ? "white" : "#2f72b3",
                        color: !isSelected ? "white" : "#2f72b3",
                        fontWeight: 500,
                      }}
                    >
                      {option?.count}
                    </Box>
                  )}
                </Box>
              </motion.div>
            );
          })
        )}
      </Box>

      <Box pl={1} sx={{ display: "flex", gap: 1 }}>
        <IconButton
          sx={{
            bgcolor: "primary.main", // background color
            color: "white", // icon color
            "&:hover": {
              bgcolor: "info.dark", // optional hover effect
            },
          }}
          onClick={() => scroll("left")}
          size="small"
        >
          <Icon icon="mdi:chevron-left" width={20}  />
        </IconButton>
        <IconButton
          sx={{
            bgcolor: "primary.main", // background color
            color: "white", // icon color
            "&:hover": {
              bgcolor: "info.dark", // optional hover effect
            },
          }}
          onClick={() => scroll("right")}
          size="small"
        >
          <Icon icon="mdi:chevron-right" width={20} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default FilterTabs;
